module.exports = __webpack_public_path__ + "img/gfish.21fa7cd.webp";